module.exports = __webpack_public_path__ + "static/img/DeluxeFamilyRoom3.781cd39b.jpg";